import { useEffect, useState } from "react";
import { FaHandPointRight } from "react-icons/fa";
import apiInstance from "../utils/axios";

function GameRates() {
  const [gameRatesObject, setGameRatesObject] = useState({});
  const [gameRatesArray, setGameRatesArray] = useState([]);

  useEffect(() => {
    const fetchGameRates = async () => {
      try {
        const response = await apiInstance.get("/api/rates/getBetRatesWeb");
        setGameRatesObject(response.data);
      } catch (err) {
        console.error("Error fetching game rates:", err);
      }
    };

    fetchGameRates();
  }, []);

  useEffect(() => {
    const requiredKeys = [
      { key: "singleDigits", label: "Single Digit" },
      { key: "jodi", label: "Jodi Digit" },
      { key: "singlePana", label: "Single Pana" },
      { key: "doublePana", label: "Double Pana" },
      { key: "triplePana", label: "Triple Pana" },
      { key: "halfSangamA", label: "Half Sangam" },
      { key: "fullSangam", label: "Full Sangam" },
    ];

    const convertedArray = requiredKeys.map(({ key, label }) => ({
      rateLabel: label,
      rate: gameRatesObject[key] ?? 0,
      value: gameRatesObject[`${key}Value`] ?? 0,
    }));

    if (Object.keys(gameRatesObject).length > 0) {
      setGameRatesArray(convertedArray);
    }
  }, [gameRatesObject]);

  return (
    <section className="w-full py-5 bg-gradient-to-r from-[#4b0000] via-[#5c0a0a] to-[#3a0000] text-white">

      <div className="max-w-7xl mx-auto px-6">

        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-yellow-400">
            Game Rates
          </h2>

          <p className="text-gray-300 mt-3">
            We have the Best Game Rates for you!
          </p>
        </div>

        {/* Rates Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 text-center">

          {gameRatesArray.map((m, i) => (

            <div key={i}>

              <FaHandPointRight className="text-yellow-400 text-4xl mx-auto mb-4" />

              <h3 className="text-xl font-semibold mb-2">
                {m.rateLabel}
              </h3>

              <p className="text-yellow-400 font-bold text-2xl">
                {m.rate} KA {m.value}
              </p>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}

export default GameRates;